import { GridLegacy } from "@mui/material";
import React, { useRef, useState } from "react";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";

import Buttonbar from "./Customfields/Components/Buttonbar";
import Overzicht from "./Customfields/Components/Overzicht";

//Form
import Text from "./Customfields/InputForms/Text";
import Select from "./Customfields/InputForms/Select";
import Mobilenr from "./Customfields/InputForms/Mobilenr";
import { useController } from "react-hook-form";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormJson from "../../../components/Forms/FormJson";

function Registration(props) {
  const [showInputForm, setShowInputForm] = useState(false);

  const form = useRef(null);

  const {
    field: { value: extra_settings__registrationFieldsValue, onChange: extra_settings__registrationFieldsOnChange },
  } = useController({ name: "extra_settings__registrationFields" });

  const handleButtonClick = (type) => {
    form.current = getInputForm(type);
    if (form.current) {
      setShowInputForm(true);
    }
  };

  const handleCloseClick = () => {
    form.current = null;
    setShowInputForm(false);
  };

  const handleEdit = (row) => {
    form.current = getInputForm(row.type, row);
    if (form.current) {
      setShowInputForm(true);
    }
  };

  const onDelete = (objectToDelete) => {
    extra_settings__registrationFieldsOnChange(
      JSON.stringify(
        JSON.parse(extra_settings__registrationFieldsValue).filter((obj) => obj.name !== objectToDelete.name)
      )
    );
  };

  const onSave = (value, _, action) => {
    const arr = extra_settings__registrationFieldsValue ? JSON.parse(extra_settings__registrationFieldsValue) : [];
    if (action === "ADD") {
      arr.push(value);
    } else if (action === "EDIT") {
      arr.forEach((obj, key) => {
        if (obj.name === value.oldName) {
          delete value.oldName;
          arr[key] = value;
        }
      });
    }
    extra_settings__registrationFieldsOnChange(JSON.stringify(arr));
  };

  const getInputForm = (type, value = undefined) => {
    let form = null;
    let action = "ADD";
    if (value !== undefined) {
      action = "EDIT";
    }

    switch (type) {
      case "text":
        form = (
          <Text
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "extra_settings__registrationFields", action)}
            value={value}
            {...props}
          />
        );
        break;
      case "mobilenr":
        form = (
          <Mobilenr
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "extra_settings__registrationFields", action)}
            value={value}
            {...props}
          />
        );
        break;
      case "select":
        form = (
          <Select
            closeForm={handleCloseClick}
            onSave={(value) => onSave(value, "extra_settings__registrationFields", action)}
            value={value}
            {...props}
          />
        );
        break;
    }

    return form;
  };

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <GridLegacy item xs={6}>
            <h3>
              <TranslationWrapper
                tDefault={"Registration settings"}
                tKey={"vestigingen.form.registration.headers.registrationsettings"}
              />
            </h3>
          </GridLegacy>
          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <FormSwitchTC
              name={"extra_settings__requireRegistration"}
              tDefault={"Require registration"}
              tKey={"vestigingen.form.overige.label.extra_settings__requireRegistration"}
            />
            <FormTextTC
              name={"extra_settings__registrationTitle"}
              tDefault={"Registration title"}
              tKey={"vestigingen.form.overige.label.extra_settings__registrationTitle"}
            />
            <FormTextTC
              name={"extra_settings__registrationDescr"}
              tDefault={"Registration description"}
              tKey={"vestigingen.form.overige.label.extra_settings__registrationDescr"}
            />
            <GridLegacy item xs={12}>
              <Buttonbar checkoutShowCheckoutFields={false} disableAll={showInputForm} onClick={handleButtonClick} />
            </GridLegacy>
          </GridLegacy>

          {form.current}

          <Overzicht
            customFields={extra_settings__registrationFieldsValue}
            disableAll={showInputForm}
            onDelete={onDelete}
            onEdit={handleEdit}
          />

          <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"JSON"} tKey={"vestigingen.form.registration.headers.json"} />
              </h3>
            </GridLegacy>
            <FormJson name={"extra_settings__registrationFields"} tKey={"JSON"} />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Registration;
